export type AccountPayload = {
	id: number;
	name: string;
};

export type AccountFetchedAction = {
	type: 'ACCOUNT_FETCHED';
	payload: AccountPayload;
};

export default (payload: AccountPayload): AccountFetchedAction => ({
	type: 'ACCOUNT_FETCHED',
	payload,
});
